import GoogleApi from '../api/googleApis';
import * as Constant from '../constants/constants';
import placeModel from '../models/place';
import locationApi from '../api/locationApi';
import userApi from '../api/userApi';

export function getAutoCompletePlace(place, type, key) {
    return userApi.getAutoCompletePlace(place, type, key || Constant.KEY.GOOGLE_API_KEY).then(response => {
        if (response && response.data && Array.isArray(response.data.predictions)) {
            return placeModel.mappingObjects(response.data.predictions);
        }
        return [];
    });
}

export function getDetailPlaceViaWeb(placeId) {
    return new Promise((resolve, reject) => {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({placeId}, (res, status) => {
            if (status === 'OK') {
                if (res[0]) {
                    const filterItm = res[0].address_components.find(itm => itm.types.includes('country'));

                    const placeResult = {
                        placeId,
                        Latitude: parseFloat(res[0].geometry.location.lat()),
                        Longitude: parseFloat(res[0].geometry.location.lng()),
                        country: filterItm ? filterItm.long_name : '',
                        shortName: filterItm ? filterItm.short_name : '',
                        countryPlaceId: placeId,
                        stateName: res[0].formatted_address,
                    };
                    const results = {
                        success: true,
                        message: '',
                        data: placeResult,
                    };
                    resolve(results);
                } else {
                    const results = {
                        success: true,
                        message: 'No results found',
                        data: null,
                    };
                    resolve(results);
                }
            } else {
                reject(status);
            }
        });
    });
}

export function getCurrrentGeoLocation() {
    return GoogleApi.getCurrrentGeoLocation(Constant.KEY.GOOGLE_API_KEY).then(response => {
        if (response) {
            console.log('getCurrrentGeoLocation...', response);
            return {
                success: true,
                message: response.message,
                data: '',
            };
        }
        return {
            success: false,
            message: response.message,
            data: null,
        };
    });
}

export function getPlaceDetailFromGeoLocationV1(lat, lng, suburb = true) {
    return new Promise((resolve, reject) => {
        const geocoder = new window.google.maps.Geocoder();
        const location = {lat: parseFloat(lat), lng: parseFloat(lng)};
        geocoder.geocode({location}, (res, status) => {
            if (status === window.google.maps.GeocoderStatus.OK) {
                if (res && res.length > 0) {
                    // get locality or country
                    for (let i = 0; i < res.length; i++) {
                        if (suburb ? res[i].types[0] === 'locality' : res[i].types[0] === 'country') {
                            const placeDetail = {
                                placeId: res[i].place_id,
                                Latitude: location.lat,
                                Longitude: location.lng,
                                StateName: res[i].formatted_address,
                            };
                            const results = {
                                success: true,
                                message: '',
                                data: placeDetail,
                            };
                            resolve(results);
                        }
                    }
                    const results = {
                        success: true,
                        message: '',
                        data: null,
                    };
                    resolve(results);
                } else {
                    const results = {
                        success: true,
                        message: 'No results found',
                        data: null,
                    };
                    resolve(results);
                }
            } else {
                reject(status);
            }
        });
    });
}

export function getPlaceDetailFromGeoLocation(lat, lng) {
    return GoogleApi.getPlaceDetailFromGeoLocation(lat, lng, Constant.KEY.GOOGLE_API_KEY).then(res => {
        const response = res.data;
        if (response.results.length > 0) {
            if (response.results.length === 1) {
                const placeDetail = {};
                placeDetail.lat = lat;
                placeDetail.lng = lng;
                placeDetail.placeId = response.results[0].place_id;
                return {
                    success: true,
                    message: response.status,
                    data: placeDetail,
                };
            }
            for (let i = 0; i < response.results.length; i++) {
                if (response.results[i].types[0] === 'administrative_area_level_2') {
                    const placeDetail = {};
                    placeDetail.lat = lat;
                    placeDetail.lng = lng;
                    placeDetail.placeId = response.results[i].place_id;
                    return {
                        success: true,
                        message: response.status,
                        data: placeDetail,
                    };
                }
            }
            return {
                success: true,
                message: response.status,
                data: null,
            };
        }
        return {
            success: false,
            message: response.status,
            data: null,
        };
    });
}

// NhatDo
export function getPlaceFromCurrentLocation(lat, lng, key) {
    // console.log(lat, lng)
    const body = {};
    body.IsSuburbOnly = true;
    body.Lat = lat;
    body.Lon = lng;
    return locationApi.locationAutoComplete(body).then(res => {
        if (res.success) {
            if (res.data && res.data.items && res.data.items.length > 0) {
                const placeDetail = {};
                placeDetail.lat = lat;
                placeDetail.lng = lng;
                placeDetail.placeId = res.data.items[0].LocationID;
                placeDetail.stateName = res.data.items[0].Text;
                return {
                    success: true,
                    data: placeDetail,
                    message: '',
                };
            }
            return {
                success: true,
                data: null,
                message: '',
            };
        }
        return {
            success: false,
            message: res.message,
            data: null,
        };
    });
}

export function getPlaceFromCurrentLocationGoogleApi(lat, lng) {
    return GoogleApi.getPlaceDetailFromLatLng(lat, lng, Constant.KEY.GOOGLE_API_KEY_IOS).then((response) => {
        if (response.data.results.length > 0) {
            if (response.data.results.length === 1) {
                let placeDetail = {};
                placeDetail.lat = lat;
                placeDetail.lng = lng;
                placeDetail.placeId = response.data.results[0].place_id;
                placeDetail.stateName = response.data.results[0].formatted_address;
                for (let i = 0; i < response.data.results[0].address_components.length; i++) {
                    if (response.data.results[0].address_components[i].types[0] === "country") {
                        placeDetail.countryCode = response.data.results[0].address_components[i].short_name;
                    }
                }
                return {
                    success: true,
                    message: response.status,
                    data: placeDetail
                };

            } else {
                for (let i = 0; i < response.data.results.length; i++) {
                    if (response.data.results[i].types[0] === "locality") {
                        let placeDetail = {};
                        placeDetail.lat = lat;
                        placeDetail.lng = lng;
                        placeDetail.placeId = response.data.results[i].place_id;
                        placeDetail.stateName = response.data.results[0].formatted_address;
                        for (let i = 0; i < response.data.results[0].address_components.length; i++) {
                            if (response.data.results[0].address_components[i].types[0] === "country") {
                                placeDetail.countryCode = response.data.results[0].address_components[i].short_name;
                            }
                        }
                        return {
                            success: true,
                            message: response.status,
                            data: placeDetail
                        };

                    }
                }
                return {
                    success: true,
                    message: response.status,
                    data: null
                };
            }

        } else {
            return {
                success: false,
                message: response.status,
                data: null
            };
        }
    });
}

export function getPlaceDetailFromCoordinates(lat, lng) {
    return new Promise((resolve, reject) => {
        const geocoder = new window.google.maps.Geocoder();
        const location = {lat: parseFloat(lat), lng: parseFloat(lng)};
        geocoder.geocode({location}, (res, status) => {
            if (status === window.google.maps.GeocoderStatus.OK) {
                if (res && res.length > 0) {
                    let locality;
                    let country = {};
                    const resLength = res.length;
                    // get locality and country
                    for (let i = 0; i < resLength; i++) {
                        if (res[i].types[0] === 'locality') {
                            locality = {
                                latitude: location.lat,
                                longitude: location.lng,
                                placeId: res[i].place_id,
                                stateName: res[i].formatted_address,
                                LocationType: 'locality',
                            };
                        }
                        if (res[i].types[0] === 'country') {
                            country = {
                                latitude: location.lat,
                                longitude: location.lng,
                                placeId: res[i].place_id,
                                stateName: res[i].formatted_address,
                                LocationType: 'country',
                            };
                        }
                    }
                    const results = {
                        success: true,
                        message: '',
                        data: {locality, country},
                    };
                    resolve(results);
                } else {
                    const results = {
                        success: true,
                        message: 'No results found',
                        data: null,
                    };
                    resolve(results);
                }
            } else {
                reject(status);
            }
        });
    });
}

export function getPlaceDetailAndCountryFromGeoLocation(lat, lng) {
    return new Promise((resolve, reject) => {
        const geocoder = new window.google.maps.Geocoder();
        const location = {lat: parseFloat(lat), lng: parseFloat(lng)};
        geocoder.geocode({location}, (res, status) => {
            if (status === window.google.maps.GeocoderStatus.OK) {
                if (res && res.length > 0) {
                    let placeDetail = {};
                    // Get place with type is administrative_area_level_3, city and country
                    for (let i = 0; i < res.length; i++) {
                        // get place
                        if (res[i].types[0] === 'administrative_area_level_3') {
                            placeDetail = {
                                ...placeDetail,
                                placeId: res[i].place_id,
                                Latitude: location.lat,
                                Longitude: location.lng,
                                // StateName: res[i].formatted_address
                            };
                        }
                        // get city
                        if (res[i].types[0] === 'administrative_area_level_1') {
                            placeDetail = {
                                ...placeDetail,
                                StateName: res[i].address_components[0].long_name,
                                // cityShortName: res[i].address_components[0].short_name,
                            };
                        }
                        // get country
                        if (res[i].types[0] === 'country') {
                            placeDetail = {
                                ...placeDetail,
                                countryPlaceId: res[i].place_id,
                                countryLongName: res[i].address_components[0].long_name,
                                countryShortName: res[i].address_components[0].short_name,
                            };
                        }
                    }
                    const results = {
                        success: true,
                        message: '',
                        data: placeDetail,
                    };
                    resolve(results);
                } else {
                    const results = {
                        success: true,
                        message: 'No results found',
                        data: null,
                    };
                    resolve(results);
                }
            } else {
                reject(status);
            }
        });
    });
}

export function rad(x) {
    return (x * Math.PI) / 180;
}

// ---------------------------------------
// Calculate distance between two points
// p1 and p2 are google.maps.LatLng(x,y) objects: { lat: latitude value, long: longitude value }
// returns the distance in meter
// ---------------------------------------
export function calcDistance(p1, p2) {
    const R = 6378137; // Earth’s mean radius in meter
    const p1LatLng = new window.google.maps.LatLng(p1.lat, p1.long);
    const p2LatLng = new window.google.maps.LatLng(p2.lat, p2.long);

    const dLat = rad(p2LatLng.lat() - p1LatLng.lat());
    const dLong = rad(p2LatLng.lng() - p1LatLng.lng());
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(rad(p1LatLng.lat())) * Math.cos(rad(p2LatLng.lat())) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c;
    return d;
}
